const getDefaultState = () => {
    return {
        sekolahData: [],
        sekolahnya: [],
        errors: []
    }
  }

export const RESET_SEKOLAH = (state) => {
    state = Object.assign(state, getDefaultState())
}

export const SET_SEKOLAH = (state, sekolah) => {
    state.sekolahData = sekolah;
}

export const SET_SEKOLAHNYA = (state, sekolahnya) => {
    state.sekolahnya = sekolahnya;
}

export const SET_ERRORS_FORM_SEKOLAH = (state, errors) => {
    state.errors = errors;
}

export const UNSET_ERRORS_FORM_SEKOLAH = (state, errors) => {
    state.errors = [];
}

export const UNSET_ERROR_PROSEK = (state, errors) => {
    state.error_prosek = [];
}

export const SET_ERROR_PROSEK = (state, errors) => {
    state.error_prosek = errors;
}

export const SET_TITIK_SOLO = (state, payload) => {
    state.titikSolo = payload;
}